import { default as routes } from './model/routes';
import * as layout from './views/layout';

export default { ...routes, layout };
